import {useEffect, useState} from "react"

export interface WidgetEditState {
    isFullEditor: boolean
    setIsFullEditor: (value: boolean) => void
    stopEditing: () => void
}

/**
 * Shared state for widgets that switch between an inline editor and a full
 * editor. Resets the local flag and notifies the parent when editing stops.
 */
export function useWidgetEditState(onStopEditing: () => void, readOnly = false): WidgetEditState {
    const [isFullEditor, setIsFullEditor] = useState(false)

    useEffect(() => {
        if (readOnly) setIsFullEditor(false)
    }, [readOnly])

    const stopEditing = () => {
        setIsFullEditor(false)
        onStopEditing()
    }

    return {isFullEditor, setIsFullEditor, stopEditing}
}
